/*
 * @Description: DBRank100
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2020-05-11 13:28:31
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Top100.css';
import RankTable from './../../components/Ranktable'
import Article from './../../components/Article'
import moment from 'moment'

class Top100 extends React.Component {
  constructor(props){
    super(props);

    this.state={
      time: null,
      aa: 0
    }

  }

  componentWillMount() {
    if(this.state.time==null){
      if(moment().format('a') == 'pm'){
        this.setState({time:`${moment().subtract(7,'days').format('YYYY-MM-DD')},${moment().subtract(1,'days').format('YYYY-MM-DD')}`})
      }else{
        this.setState({time:`${moment().subtract(8,'days').format('YYYY-MM-DD')},${moment().subtract(2,'days').format('YYYY-MM-DD')}`})
      }             
    }
  }

  getArtTime = (ss) => {
    this.setState({
      time:ss
    })
  }

  render() {
    return (
      <div className={s.root}>
        <RankTable rank='ranking'  getArtTime={this.getArtTime}/>
        <Article time={this.state.time} />
      </div>
    );
  }
}

export default withStyles(s)(Top100);



// WEBPACK FOOTER //
// src/routes/top100/Top100.js